import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import React, { useEffect, useMemo, useState } from "react";
import { getValidationSchema, initialValues, isEmpty } from './helpers'
import { useFormik } from 'formik'
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress, Grid, Typography } from '@mui/material'
import { useNotification } from 'hooks'
import { makeCoreGetRequest, makeCorePostRequest } from 'utils/api'
import { useMutation, useQuery } from 'react-query'
import { formatErrorMessage } from 'utils/formatting'
import { URLS } from 'components/shop-reception/mobile/constants'
import SourceIcon from '@mui/icons-material/Source'

const CreateTruckStep1 = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { showNotification } = useNotification()

  const [truckId, setTruckId] = useState(0)

  useEffect(() => {
    const id = location.state

    if (id) {
      loadTruck(id);
      setTruckId(id);
    }
  }, [location])

  const loadTruck = id => {
    try {
      makeCoreGetRequest(`/shop-reception-mobile/truck/shop/truck-creation/${id}`).then(truck => {
        formik.setValues({
          truckNumber: truck.truckNumber,
          driverName: truck.driverName,
          sealList: truck.sealList
        })
      })
    } catch (error) {
      showNotification({
        message: `Error while fetching truck. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const { data: hubName, isLoading: isLoadingHubName } = useQuery(
    ['hub-name'],
    async () => {
      const response = await makeCoreGetRequest('/shop-reception-mobile/home/hub-name')
      return response || []
    },
    {
      onError: error => {
        showNotification({
          message: `A aparut o eroare la obtinerea datelor despre hub. ${formatErrorMessage(
            error
          )}`,
          type: 'error'
        })
      }
    }
  )

  const createTruck = async (values: any) => {
    return await makeCorePostRequest(`/shop-reception-mobile/truck/shop/create-truck`, { ...values, id: truckId })
  }

  const { isLoading, mutate } = useMutation(createTruck, {
    onSuccess: (res) => {
      showNotification({
        message: 'Camionul a fost creat cu success.',
        type: 'success'
      })
      navigate(URLS.AUTH_CREATE_TRUCK_STEP_2, { state: { truckId: res.id } })
    },
    onError: error => {
      showNotification({
        message: `A aparut o eroare ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  })

  const validationSchema = useMemo(() => getValidationSchema(), [])
  const formik = useFormik({
    enableReinitialize: false,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      mutate(values)
    }
  })

  const disableNextButton =
    isEmpty(formik.values.driverName) ||
    isEmpty(formik.values.truckNumber) ||
    formik.values.sealList.some(seal => isEmpty(seal.code))

  return (
    <Grid container spacing={2} justifyContent={'center'}>
      <Typography
        component="h2"
        variant="medium"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
        pt={2}
      >
        {hubName?.value}
      </Typography>
      <Grid xs={10} item>
        <Input
          type="text"
          value={formik.values.truckNumber}
          onChange={event =>
            formik.setFieldValue('truckNumber', (event.target as HTMLInputElement).value)
          }
          label="Numar inmatriculare"
          variant="outlined"
          style={{ width: '100%' }}
          error={!!formik.errors.truckNumber}
          helperText={formik.errors.truckNumber as string}
          required
        />
      </Grid>
      <Grid xs={10} item>
        <Input
          type="text"
          value={formik.values.driverName}
          onChange={event =>
            formik.setFieldValue('driverName', (event.target as HTMLInputElement).value)
          }
          label="Sofer"
          variant="outlined"
          style={{ width: '100%' }}
          error={!!formik.errors.driverName}
          helperText={formik.errors.driverName as string}
          required
        />
      </Grid>
      {formik.values.sealList.map((seal, index) => (
        <>
          <Grid xs={10} item>
            <Input
              id={`seal-${index}`}
              type="text"
              value={seal.code}
              onChange={event =>
                formik.setFieldValue(
                  `sealList[${index}].code`,
                  (event.target as HTMLInputElement).value
                )
              }
              label="Numar sigiliu"
              variant="outlined"
              style={{ width: '100%' }}
              error={!!formik.errors.sealList}
              helperText={formik.errors.sealList as string}
              required
            />
          </Grid>

          <Grid xs={10} item>
            <Button
              variant="outlined"
              children={<SourceIcon />}
              label=""
              onClick={() => document.getElementById(`seal-${index}`).focus()}
              style={{ width: '100%' }}
            />
          </Grid>
        </>
      ))}
      {formik.values.sealList.length < 3 && (
        <Grid xs={10} item>
          <Button
            variant="outlined"
            label="Adauga alt sigiliu"
            onClick={() =>
              formik.setFieldValue('sealList', [...formik.values.sealList, { code: null }])
            }
            style={{ width: '100%' }}
          />
        </Grid>
      )}
      <Grid xs={10} item>
        <Button
          variant="outlined"
          label="Pasul urmator"
          onClick={() => formik.handleSubmit()}
          style={{ width: '100%' }}
          disabled={disableNextButton || isLoading}
        />
      </Grid>
    </Grid>
  )
}

export default CreateTruckStep1
